export class OrderPackagesInRouteDto {
	public routeId: number;
	public packages: Array<OrderPackageInRouteDto>;

	static build(routeId: number, packages: Array<OrderPackageInRouteDto>): OrderPackagesInRouteDto{
		let result = new OrderPackagesInRouteDto();
		result.routeId = routeId;
		result.packages = packages;
		return result;
	}
}

export class OrderPackageInRouteDto {
	public packageId: number;
	public orderInRoute: number;

	static build(packageId: number, orderInRoute: number): OrderPackageInRouteDto{
		let result = new OrderPackageInRouteDto();
		result.packageId = packageId;
		result.orderInRoute = orderInRoute;
		return result;
	}
}